module.exports = __webpack_public_path__ + "img/big3.7c588de8.jpg";